/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { FC, useCallback } from "react";
import { DesignContext } from "@adapptio/lib-blueprint";
import { ResourceService } from "../../../resources/ResourceService";
import { getReferenceListData } from "./getReferenceListData";
import { useCommand } from "../../hooks";
import { IReferenceListItem, ReferenceList } from "./ReferenceList";
import { Panel, PANEL_STYLE } from "../Panel";

export interface IReferenceListPanel {
	resourceId: string;
	resourceService: ResourceService;
	dCtx: DesignContext;
}

export const ReferenceListPanel: FC<IReferenceListPanel> = ({ resourceId, resourceService, dCtx }) => {
	const [ openResource ] = useCommand("resource.open");
	const { dependsOn, referencedBy } = getReferenceListData(resourceId, resourceService, dCtx);

	const onItemClick = useCallback((ref: IReferenceListItem) => {
		console.log("Open", ref.id);
		openResource(ref.id);
	}, []);

	return (
		<Panel style={PANEL_STYLE.BASE} scroll={true}>
			<ReferenceList
				referencedBy={referencedBy}
				dependsOn={dependsOn}
				onItemClick={onItemClick}
			/>
		</Panel>
	);
};
